// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadCurrentShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import { getCurrentShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import constants from "@store/constants";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/TrailerTracking/Handlers/UpdateSearchFields";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    return {
        currentShipTosDataView: getCurrentShipTosDataView(state),
        parameter: state.greif.pages.trailerTracking.getTrailersParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    loadCurrentShipTos,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface TrailerTrackingSearchFieldShipToStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const shipToStyles: TrailerTrackingSearchFieldShipToStyles = {};
const styles = shipToStyles;

const TrailerTrackingSearchFieldShipTos = ({
    currentShipTosDataView,
    parameter,
    updateSearchFields,
    loadCurrentShipTos,
}: Props) => {
    const [selectedShipTo, setSelectedShipTo] = useState<string>("");

    useEffect(() => {
        if (!currentShipTosDataView.value) {
            loadCurrentShipTos();
        }
    }, [currentShipTosDataView]);

    useEffect(() => {
        if (!parameter.shipToBp) {
            setSelectedShipTo("-1");
        }
    }, [parameter.shipToBp]);

    const handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        const value = event.currentTarget.value;
        const isAll = value === "-1";

        setSelectedShipTo(value);
        updateSearchFields({ shipToBp: isAll ? undefined : value });
    };

    const shipToOptions = currentShipTosDataView.value || [];

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <Select
                label={translate("Ship To")}
                {...styles.select}
                value={parameter.shipToBp || selectedShipTo}
                onChange={handleChange}
                data-test-selector="orderHistory_filterShipTo"
            >
                {shipToOptions.map(shipTo => (
                    <option key={shipTo.customerSequence} value={shipTo.customerSequence}>
                        {shipTo.label}
                    </option>
                ))}
            </Select>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TrailerTrackingSearchFieldShipTos),
    definition: {
        group: constants.widgetGroup.trailerTracking,
        displayName: "Ship To",
        allowedContexts: [constants.pageType.trailerTracking],
    },
};

export default widgetModule;
